import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=1d77130b&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d77130b')) {
      api.createRecord('1d77130b', component.options)
    } else {
      api.reload('1d77130b', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=1d77130b&", function () {
      api.rerender('1d77130b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4nfp8MiWe6vGD/JS/comp/FavElement.vue"
export default component.exports